<div class="container">
  <app-shell
    style="width: 100%; height: 100%"
    [homeState]="this.homeState"
    [bpState]="this.bpState"
    [needsProgressBars]="false"
  >
    <div class="stack">
      <div id="question">
        <h1>{{ this.headerText }}</h1>
      </div>
      <app-kendo-dropdown
        [dropdownHeaderText]="'Document Type dropdown'"
        [options]="options"
        formControlName="state"
        (selectionChange)="onChange($event)"
      ></app-kendo-dropdown>
      <div class="files">
        <app-file-drop-zone
          [onSubmit]="this.onSubmit.bind(this)"
          formControlName="filesData"
          [uploadSaveUrl]="this.uploadSaveUrl"
          [uploadRemoveUrl]="this.removeSaveUrl"
          [documentType]="this.selectedDocumentType"
          [parentForm]="form"
          [multipleFile]="true"
          [showFilesInDropzone]="true"
        >
        </app-file-drop-zone>
      </div>
      <app-document-upload-table
        [documentBehaviorSubject]="this.documentBehaviorSubject"
        [onDelete]="this.onDelete.bind(this)"
        [onDownload]="this.onDownload.bind(this)"
      ></app-document-upload-table>
    </div>
  </app-shell>
</div>
